import { AppState } from '../../state';
import { initialState, SubscribeState } from './reducer';

export const getSubscribe = (
  state: AppState,
): SubscribeState => (
  state.subscribe
    ? state.subscribe
    : initialState
);
